require(['jquery', 'validate', 'unobtrusive'], function ($) {
    'use strict';

    $('.masked-phone input:not(.masked-phone-anchor)').on('keydown', function (e) {
        if (e.which === 13) {
            assemblyPhone(this);
        }
    });

    $('.masked-phone input:not(.masked-phone-anchor)').on('blur', function () {
        assemblyPhone(this);
    });

    function assemblyPhone(elem) {
        var parent = $(elem).parent(),
            children = parent.children(),
            anchor = children[0],
            area = children[1],
            prefix = children[2],
            line = children[4];

        anchor.value = area.value + prefix.value + line.value;
        $(anchor).valid();
    }
});
define("validateMaskedPhone", function(){});

